<template>
  <section class="intro" @click="start">
    <img src="../assets/NADA01_iPad.jpg" alt="Introducing OnStar Guardian App" />
  </section>
</template>

<script>
export default {
  name: "Intro",
  methods: {
    start() {
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="scss">
.mobile {
  overflow: auto;
}
.intro {
  color: #fff;
  background-color: #000;
  height: 100%;
  width: 100%;

  img {
    width: 100%;
  }

  h1 {
    margin: 0;
  }

  img:hover {
    cursor: pointer;
  }
}
</style>